import { render, staticRenderFns } from "./Giorno.vue?vue&type=template&id=f7ea85f8&scoped=true&"
import script from "./Giorno.vue?vue&type=script&lang=js&"
export * from "./Giorno.vue?vue&type=script&lang=js&"
import style0 from "./Giorno.vue?vue&type=style&index=0&id=f7ea85f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7ea85f8",
  null
  
)

export default component.exports